<template>
  <div class="adminDetails">
    <!-- 侧边栏收缩图标 -->
    <div class="sideBarBtn" v-if="sideBarShow">
      <i
        @click="handleSideBarBtnClick"
        v-if="!isSideBarShow"
        style="font-size:24px;color:#128bf1;"
        class="el-icon-s-unfold"
      ></i>
      <i
        @click="handleSideBarBtnClick"
        v-if="isSideBarShow"
        style="font-size:24px;color:#128bf1;"
        class="el-icon-s-fold"
      ></i>
    </div>
    <!-- 侧边栏 -->
    <transition style="width:270px" name="el-zoom-in-top" v-if="sideBarShow">
      <ul v-show="isSideBarShow" class="leftSideBar">
        <li :class="containerType=='0'?'activeSideBarBlue':''" @click="sideBarClick('0')">详情页</li>
        <li
          :class="containerType==item.code?'activeSideBarBlue':''"
          v-for="item in aboutList"
          :key="item.code"
          @click="sideBarClick(item.code)"
        >
          {{item.show_name+`(${item.count})`}}
          <span v-if="item.money_state==1">
            <span>(</span>
            <span style="color: rgb(245, 95, 95);">{{`${item.money}元`}}</span>
            <span>)</span>
          </span>
        </li>
      </ul>
    </transition>
    <!-- 详情栏 -->
    <div class="detailsBox" v-if="containerType=='0'">
      <!-- 邮寄 -->
      <mail-form v-if="showForm == 'showFormAdd' || showForm =='showFormHandle'" />
      <!-- 报告用章 -->
      <report-form v-if="showForm == 'showFormClearAdd' || showForm =='showFormClearHandle'" />
      <!-- 其他用章 -->
      <chapter-form v-if="showForm == 'showFormZhuanAdd' || showForm =='showFormZhuanHandle'" />
      <!-- 合同用章 -->
      <ht-form v-if="showForm == 'showFormHtAdd' || showForm =='showFormHtHandle'" />
      <!-- 合同存档 -->
      <htsave-form v-if="showForm == 'showFormHtSaveAdd' || showForm =='showFormHtSaveHandle'" />
      <!-- 外部用章 -->
      <extrenal-form
        v-if="showForm == 'showFormExtrenalAdd' || showForm =='showFormExtrenalHandle'"
      />
      <!-- 公示存档 -->
      <announce-form
        v-if="showForm == 'showFormAnnounceAdd' || showForm =='showFormAnnounceHandle'"
      />
      <!-- 告知书 -->
      <notify-form
        v-if="showForm == 'showFormNotifyAdd' || showForm =='showFormNotifyHandle'"
      />
    </div>
    <!-- 表格栏 -->
    <div class="tableDetailsBox" v-else>
      <div v-if="sideBarReset">
        <!-- 报销 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='reimbursement'"
        >
          <el-table-column :show-overflow-tooltip="true" prop="title" align="center" label="报销内容"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" align="center" label="申请人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="total" align="center" label="报销金额"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 项目结算 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='settlement'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="申请人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="total" align="center" label="结算金额"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 业务结算 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='business'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="申请人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="total" align="center" label="结算金额"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 项目专家费 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='expert'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="申请人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="total" align="center" label="金额"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 合同登记 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='contract'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="登记人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="total" align="center" label="合同金额"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 邮寄 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='mail'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="申请人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="business_name"
            align="center"
            label="物品名"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 报告用章 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='report'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="申请人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="business_name"
            align="center"
            label="项目名称"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 其他用章 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='chapter'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="申请人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="business_name"
            align="center"
            label="内容"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 合同用章 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='contract_seal'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="申请人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="business_name"
            align="center"
            label="项目名称"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 到账记录 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='arrival'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="登记人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="total" align="center" label="金额"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 合同存档 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='contract_archive'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="登记人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
        <!-- 外部用章 -->
        <el-table
          :header-cell-style="{background:'#40A0F2', padding:'20px 0',color:'#fff',fontSize:'18px',fontWeight:'400'}"
          :cell-style="{borderBottom:'none', color:'#333',fontSize:'16px',padding:'13px 0',fontWeight:'400'}"
          :data="sideBarList"
          v-if="containerType=='external_seal'"
        >
          <el-table-column :show-overflow-tooltip="true" align="center" label="申请人">
            <template slot-scope="scope">
              <span v-if="scope.row.member">{{scope.row.member.nickname}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            prop="business_name"
            align="center"
            label="内容"
          ></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="show_time" align="center" label="时间"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex'
// 引入表单组件
import ChapterForm from '../../components/finance/admin/ChapterForm'
import HtForm from '../../components/finance/admin/HtForm'
import HtsaveForm from '../../components/finance/admin/HtsaveForm'
import MailForm from '../../components/finance/admin/MailForm'
import ReportForm from '../../components/finance/admin/ReportForm'
import ExtrenalForm from '../../components/finance/admin/ExtrenalForm'
import AnnounceForm from '../../components/finance/admin/AnnounceForm'
import NotifyForm from '../../components/finance/admin/NotifyForm'

export default {
  data() {
    return {
      sign_pic: '',
      receiverSignFlag: false,

      sideBarReset: false,
      isSideBarShow: false,
      sideBarList: [],

      k_code: '',
      // 弹窗
      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',
    }
  },
  props: [],
  components: {
    ChapterForm,
    HtForm,
    HtsaveForm,
    MailForm,
    ReportForm,
    ExtrenalForm,
    AnnounceForm,
    NotifyForm,
  },
  methods: {
    ...mapMutations('process/admin', ['getContainerType']),
    async sideBarClick(val) {
      this.sideBarList = []
      this.sideBarReset = false
      setTimeout(() => {
        this.sideBarReset = true
      }, 0)
      this.getContainerType(val)
      if (val != 0) {
        let param = new FormData()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('cache_department_id', this.cache_department_id)
        param.append('company_id', this.company_id)

        param.append('finance_id', this.formData.id)
        param.append('stage_code', this.finance_stage_getter)

        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Finance/ass_' + this.containerType,
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.sideBarList = res.datas.listInfo

        console.log('liebiao', this.sideBarList)
      }
    },
    handleSideBarBtnClick() {
      this.isSideBarShow = !this.isSideBarShow
    },
  },
  computed: {
    ...mapGetters('process', {
      finance_stage_getter: 'admin/finance_stage',
    }),
    ...mapState('process/admin', [
      'sideBarShow',
      'containerType',
      'aboutList',
      'showForm',
      'formData',
    ]),
  },
  created() {
    console.log('adminDetail加载了')
    console.log('this.$route.query.type', this.$route.query.type)
    this.activeName = this.$route.query.type
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''
  },
  mounted() {},
}
</script>
<style lang="less" scoped>
@import url(../../views/topBar/finance.scss);
</style>